import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { msalInstance } from './config/auth';
import { theme } from './config/theme';
import { store } from './store';
import { environment } from './config/environment';
import App from './App';

// Check if dev auth is disabled
if (environment.devAuthOff) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
} else {
  // Initialize MSAL before rendering the app
  msalInstance.initialize().then(() => {
    return msalInstance.handleRedirectPromise();
  }).then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <Provider store={store}>
          <MsalProvider instance={msalInstance}>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
              </ThemeProvider>
            </BrowserRouter>
          </MsalProvider>
        </Provider>
      </React.StrictMode>
    );
  }).catch(error => {
    console.error('MSAL initialization failed:', error);
    
    // Handle PKCE errors by clearing cache and retrying
    if (error.message?.includes('code_verifier') || error.message?.includes('invalid_grant')) {
      try {
        msalInstance.clearCache();
        localStorage.clear();
        sessionStorage.clear();
        // Redirect to clean login
        window.location.href = window.location.origin;
        return;
      } catch (clearError) {
        console.error('Failed to clear cache:', clearError);
      }
    }
    
    document.getElementById('root')!.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h2>Authentication Error</h2>
        <p>Failed to initialize authentication: ${error.message}</p>
        <button onclick="window.location.reload()" style="margin-top: 10px; padding: 8px 16px;">Retry</button>
      </div>`;
  });
}